import styles from "./TaskCardList.module.css";

export const getTaskId = (id: string | { $oid: string }): string =>
  typeof id === "object" ? id.$oid : id;

export const truncateHash = (hash: string) =>
  `${hash.slice(0, 6)}...${hash.slice(-4)}`;

export const formatPayment = (payment: string) => {
  const num = Number(payment);
  if (isNaN(num)) {
    return "0";
  }
  const decimalPlaces = (num.toString().split(".")[1] || "").length;
  return decimalPlaces > 4 ? num.toFixed(4) : num.toString();
};

export const formatTimeRemaining = (timestamp: number) => {
  const diff = timestamp - Date.now();
  const absDiff = Math.abs(diff);
  const seconds = Math.floor(absDiff / 1000);
  if (seconds < 60) {
    return `${seconds}s`;
  }
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `${minutes}m`;
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours}h`;
  }
  const days = Math.floor(hours / 24);
  return `${days}d`;
};

export const getStatusConfig = (status: string) => {
  switch (status) {
    case "New":
      return { colorClass: styles.badgePrimary, text: "New" };
    case "Attempted":
      return { colorClass: styles.badgeWarning, text: "Attempted" };
    case "Completed":
    case "Responded":
    case "Finalized":
      return { colorClass: styles.badgeSuccess, text: status };
    default:
      return { colorClass: styles.badgePrimary, text: status };
  }
};
